<template>
  <div class="py-4 lg:pt-20">
    <div class="pt-10 bg-theme-light rounded-lg text-center">
      <img src="@/assets/icons/orderConfirm.svg" class="mx-auto">
      <div class="p-5-5 font-medium">
        <p class="text-blue text-xl">
          Thanks for submitting your Expert Sourcing Order.
        </p>
        <p>Your order number is: {{ reference_number }}</p>
        <p>We will match your order to a BuyHive Sourcing Expert within 2-3 working days.</p>
        <p>After the match, we might contact you again if your Sourcing Expert has any questions about your project.</p>
        <p class="mt-8">
          The Sourcing Expert assigned to your project will be able to recommend 3-5 suitable suppliers in the Sourcing Report.
          <br class="hidden lg:inline"/>
          We will notify you by email as soon as your Report is ready, and you can expect that to happen within 10 days after the match.
        </p>
        <p class="mt-8">
          Any questions? E-mail us at
          <a :href="`mailto: ${supportMail}`" class="text-blue font-semibold underline">
            {{ supportMail }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'OrderConfirmation',
  data(){
    return{
      supportMail: process.env.VUE_APP_SUPPORT_MAIL,
    }
  },
  computed: {
    ...mapGetters([
      'isUserLoggedIn'
    ])
  },
  beforeMount() {
    if (!this.isUserLoggedIn) {
      this.LoginSelectionMode('buyer')
      this.$router.push({name: 'LoginFormv2'})
    }
  },
  beforeDestroy() {
    let userFormData = {
            companyData: null,
            productData: null,
            supplierData: null,
            paymentData: null,
          }
    this.setUserData(userFormData)
    this.setCurrentTab(null)
    this.setSourcingRequestToken(null),
    this.setSummaryRecords(null)
  },
  methods: {
  ...mapMutations([
      'setUserData',
      'setCurrentTab',
      'setSourcingRequestToken',
      'setSummaryRecords'
    ]),
    ...mapActions([
      'LoginSelectionMode'
    ])
  },
  props:{
    reference_number: {
      type:Number,
      default:null
    }
  },
}
</script>
